export default {
  'usermenu.dialog.title': 'Message',
  'usermenu.dialog.content': 'Are you sure you would like to logout?',
  'userLayout.title': 'Ant Design',
}
